import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Formik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { forgotPassword } from '../AuthActions';
import CommonButton from '../../common/components/CommonButton';
import validationSchema from './ForgotPasswordPage.schema';
import FormInputField, {
  FormInputFieldType,
} from '../../common/components/formFields/FormInputField';
import { CommonButtonVariants } from '../../constants/CommonButtonVariants';
import RouterPaths from '../../constants/RouterPaths';
import logo from '../../assets/img/logo.png';
import logoMobile from '../../assets/img/icons/logo-mobile.svg';
import { useMediaQuery } from '../../common/hooks/useMediaQuery';
import arrowBack from '../../assets/img/icons/arrow_back.svg';

const { DISABLED, PRIMARY_RED } = CommonButtonVariants;

const initialValues = {
  email: '',
};

function ForgotPasswordPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isLoading = useSelector((state) => state.navbarLoader.get('isLoading'));

  const isMobile = useMediaQuery('(max-width: 768px)');

  const handleSubmit = async ({ email }, { setFieldValue, setSubmitting }) => {
    try {
      await dispatch(forgotPassword({ email }));
    } catch (err) {
      setFieldValue('email', email, false);
    } finally {
      setSubmitting(false);
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleSignUpClick = () => {
    navigate(RouterPaths.REGISTER);
  };

  const authLogo = isMobile ? logoMobile : logo;

  return (
    <div className="auth__page">
      <div className="auth__container">
        <div className="auth__credentials-section">
          <div className="auth__header">
            <Link to={RouterPaths.HOMEPAGE} className="auth__logo-link">
              <img src={authLogo} alt="The Stock Vault" className="auth__logo" />
            </Link>
            <CommonButton
              className="auth__back-button"
              type="button"
              label="Back"
              variant={CommonButtonVariants.OUTLINED}
              icon={arrowBack}
              iconAlt="Back to homepage"
              iconLeft
              handleClick={handleBackClick}
            />
          </div>
          <div className="auth__form-wrapper">
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}
            >
              {() => (
                <Form className="auth__form">
                  <h3 className="auth__heading">Reset password</h3>
                  <p className="auth__forgot-password-description">
                    Enter your email address below and we’ll email you a link with further
                    instructions to reset your password.
                  </p>
                  <FormInputField
                    labelVariant="bordered"
                    inputClassName="auth__forgot-password-input-field"
                    wrapperClassName="auth__forgot-password-input-wrapper"
                    name="email"
                    type={FormInputFieldType.EMAIL}
                    label="Email"
                    required
                    aria-describedby="email-error"
                  />
                  <CommonButton
                    type="submit"
                    label="Reset Password"
                    className="auth__forgot-password-button"
                    disabled={isLoading}
                    variant={isLoading ? DISABLED : PRIMARY_RED}
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
